import { h, render, Component } from 'preact';
import { classNames} from '../utils/utils';

class TxrPasswordInput extends Component {
    state = {
        pwdDisplay: false
    }

    getFirstError = ()  => {
        let errors = Object.entries(this.props.model.errors);
        let firstError = '';
        for (const [key, value] of errors) {
            if(!!value) {
             firstError = this.props.errors[key];
             this.hasError = true;
             return firstError;
            }
        }
        this.hasError = false;
        return '';
     }
     txrEdit = (e) => {
        this.props.model.touched = true;
        this.props.model.value = e.target.value;
        if(this.props.model.change) {
            this.props.model.change(this.props.model);
        }
    }
   txrEditChange = (e) => {
        this.props.model.touched = true;
        this.props.model.value = e.target.value;
        if(this.props.model.change) {
            this.props.model.change(this.props.model);
        }
    }
    togglePwdDisplay() {
        this.setState({pwdDisplay: !this.state.pwdDisplay})
    }

    render() {
        return (
            <div class={'txr-password-input' + (this.props.model.invalid ? ' invalid' : '') + (this.props.model.value || this.props.existvalue ? ' has-value' : '')}>
                <div class="txr-input__container">
                    <input onKeyup={(e) => this.txrEdit(e)} onChange={(e) => this.txrEditChange(e)} class="txr-input__input" type={ this.state.pwdDisplay ? 'text': 'password'} 
                    autocomplete={this.props.autocomplete ? this.props.autocomplete: '' } name={this.props.name ? this.props.name: '' }   value={this.props.model.value}/>  
                    <label class="txr-input__label">{this.props.label}</label>
                    <div class="txr-input__right-slot">
                            <i class={classNames({'fas': true, 'fa-eye-slash': !this.state.pwdDisplay, 'fa-eye': this.state.pwdDisplay})} onClick={() => this.togglePwdDisplay()}></i>    
                    </div>
                </div>
                { this.props.errors &&
                    <div class="txr-input__errors">
                        {this.getFirstError()}
                    </div>
                }
                 <div class="txr-input__bottom-slot">
                        <span class={classNames({'is-valid': this.props.model.pwdMinCharacters})}><i class="far fa-minus"></i><i class="fas fa-check"></i>&nbsp;8 Characters</span>
                        <span class={classNames({'is-valid': this.props.model.pwdNumber})}><i class="far fa-minus"></i><i class="fas fa-check"></i>&nbsp;Number</span>
                        <span class={classNames({'is-valid': this.props.model.pwdSymbol})}><i class="far fa-minus"></i><i class="fas fa-check"></i>&nbsp;Symbol</span>
                 </div>
            </div>
        )
    }
}

export default TxrPasswordInput;